import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

import arrows from './modules/arrows'
import arrowSpectrums from './modules/arrowSpectrums'
import dashboard from './modules/dashboard'
import exhibition from './modules/exhibition'
import exhibitions from './modules/exhibitions'
import labels from './modules/labels'
import roles from './modules/roles'
import shoppingCart from './modules/shopping-cart'
import sign from './modules/sign'
import signTypes from './modules/sign-types'
import signs from './modules/signs'
import slogans from './modules/slogans'
import status from './modules/status'
import svg from './modules/svg'
import user from './modules/user'
import users from './modules/users'
import variant from './modules/variant'
import variants from './modules/variants'
import modals from './modules/modals'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  strict: true,
  modules: {
    arrows,
    arrowSpectrums,
    dashboard,
    exhibition,
    exhibitions,
    labels,
    roles,
    shoppingCart,
    sign,
    signTypes,
    signs,
    slogans,
    status,
    svg,
    user,
    users,
    variant,
    variants,
    modals
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js